import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sector", "retailer", "place-groups"]
  static values = {
    retailers: Array,
    placeGroups: Array
  }

  connect() {
    // Store all retailers and place groups data from the values
    this.allRetailers = this.retailersValue
    this.allPlaceGroups = this.placeGroupsValue
    this.filterRetailers() // Apply initial filtering
    this.filterPlaceGroups() // Apply initial place group filtering
  }

  filterRetailers() {
    const selectedSectorId = this.sectorTarget.value
    const retailerSelect = this.retailerTarget

    // Preserve the currently selected retailer (important for edit forms)
    const currentRetailerId = retailerSelect.value

    // Clear current options except the blank option
    retailerSelect.innerHTML = '<option value="">Select Retailer</option>'

    if (selectedSectorId) {
      // Filter retailers by sector
      const filteredRetailers = this.allRetailers.filter(retailer =>
        retailer.sector_id == selectedSectorId
      )

      // Add filtered options
      filteredRetailers.forEach(retailer => {
        const option = new Option(retailer.name, retailer.id)
        retailerSelect.add(option)
      })
    } else {
      // If no sector selected, show all retailers
      this.allRetailers.forEach(retailer => {
        const option = new Option(retailer.name, retailer.id)
        retailerSelect.add(option)
      })
    }

    // Restore the previously selected retailer if it's still in the filtered list
    if (currentRetailerId) {
      retailerSelect.value = currentRetailerId
    }

    // Also filter place groups when sector changes
    this.filterPlaceGroups()
  }

  filterPlaceGroups() {
    // Only filter if place groups target exists
    if (!this.hasPlaceGroupsTarget) return

    const selectedSectorId = this.sectorTarget.value
    const selectedRetailerId = this.retailerTarget.value
    const placeGroupsSelect = this.placeGroupsTarget

    // Get currently selected values to preserve them if they're still valid
    const currentlySelected = Array.from(placeGroupsSelect.selectedOptions).map(option => option.value)

    // Clear current options
    placeGroupsSelect.innerHTML = ''

    let filteredPlaceGroups = this.allPlaceGroups

    // Filter by sector and retailer
    if (selectedSectorId && selectedRetailerId) {
      // Both sector and retailer selected - show place groups for that specific retailer
      filteredPlaceGroups = this.allPlaceGroups.filter(pg =>
        pg.retailer_id == selectedRetailerId && pg.sector_id == selectedSectorId
      )
    } else if (selectedSectorId) {
      // Only sector selected - show place groups for that sector (sector-wide or any retailer in that sector)
      filteredPlaceGroups = this.allPlaceGroups.filter(pg =>
        pg.sector_id == selectedSectorId
      )
    } else if (selectedRetailerId) {
      // Only retailer selected - show place groups for that retailer
      filteredPlaceGroups = this.allPlaceGroups.filter(pg =>
        pg.retailer_id == selectedRetailerId
      )
    }
    // If neither selected, show all place groups

    // Add filtered options and restore selection
    filteredPlaceGroups.forEach(placeGroup => {
      const option = new Option(placeGroup.name, placeGroup.id)
      option.selected = currentlySelected.includes(placeGroup.id.toString())
      placeGroupsSelect.add(option)
    })
  }
}
